import P5 from "p5";
import MainMenuScreen from "./mainMenuScreen";
import GameScreen from "./gameScreen";
import Player from "./game/player";
import MapEditorScreen from "./mapEditorScreen";
import OptionsScreen from "./optionsScreen";
import TestScreen from "./testScreen";
import CutSceneScreen from "./cutSceneScreen";
import CreditScreen from "./creditScreen";
import StatsScreen from "./statsScreen";
import NewGameConfirmScreen from "./newGameConfirmScreen";

globalThis.showDebug = globalThis.showDebug || false;
globalThis.pixelSize = globalThis.pixelSize || 2;
globalThis.isMobile = globalThis.isMobile || false;
globalThis.renderTime = globalThis.renderTime || 0;
globalThis.renderTimeLast = globalThis.renderTimeLast || 0;
globalThis.entities = globalThis.entities || [];
globalThis.particles = globalThis.particles || [];
globalThis.currentScreen = globalThis.currentScreen || "mainMenu";
globalThis.screens = globalThis.screens || {};
globalThis.iScreen = globalThis.iScreen || null;
globalThis.buffer = globalThis.buffer || null;
globalThis.bufferTop = globalThis.bufferTop || null;
globalThis.p5js = globalThis.p5js || null;
globalThis.player = globalThis.player || null;
globalThis.font = globalThis.font || null;
// Local dev serves assets from the flask file_server (server.py) on :5001;
// a deployed build serves them from its own origin, so assets are fetched
// relative to the site root ("").
const onLocalHost = typeof location !== "undefined"
    && /^(localhost|127\.|192\.168\.)/.test(location.hostname);
globalThis.staticServer = globalThis.staticServer
    || (onLocalHost ? "http://192.168.1.217:5001" : "");

globalThis.lightImage = globalThis.lightImage || null;

const sketch = (p5 : P5) => {
    p5.preload = () => {
        p5js = p5;
        player = new Player();

        screens["mainMenu"] = new MainMenuScreen();
        screens["game"] = new GameScreen();
        screens["mapEditor"] = new MapEditorScreen();
        screens["options"] = new OptionsScreen();
        screens["cutScene"] = new CutSceneScreen();
        screens["test"] = new TestScreen();
        screens["credits"] = new CreditScreen();
        screens["stats"] = new StatsScreen();
        screens["confirmNewGame"] = new NewGameConfirmScreen();
        iScreen = screens[currentScreen];

        globalThis.lightImage = p5.loadImage(`${staticServer}/assets/light.png`);
        globalThis.font = p5.loadFont(`${staticServer}/assets/McLaren-Regular.ttf`);
    }

    p5.setup = () => {
        p5.createCanvas(p5.windowWidth, p5.windowHeight);
        p5.pixelDensity(1);

        isMobile = detectMobile();

        //use window resize event to resize canvas
        p5.windowResized();

        //setup for all screens
        for(let key in screens){
            screens[key].setup();
        }
    }

    p5.draw = () => {
        renderTime = p5.millis();
        bufferTop.clear();

        // Update screen
        iScreen.draw();

        //draw cursor
        if(!isMobile){
            drawCursor();
        }

        // Draw buffer to the main canvas, scaled up
        //BLEND, DARKEST, LIGHTEST, DIFFERENCE, MULTIPLY, EXCLUSION, SCREEN, REPLACE, OVERLAY, HARD_LIGHT, SOFT_LIGHT, DODGE, BURN, ADD, or NORMAL
        p5.noSmooth(); //why it doesn't work with WEBGL?
        // //p5.blendMode(p5.NEAREST);
        // p5.setAttributes("antialias", false);
        // p5.setAttributes("antialias", false);

        //p5.image(buffer, -p5.width/2, -p5.height/2, p5.width, p5.height);
        p5.image(buffer, 0, 0, p5.width, p5.height);
        //p5.image(bufferTop, 0, 0, p5.width, p5.height);
        renderTime = p5.millis() - renderTime;

        renderTimeLast = renderTime;
    }

    p5.windowResized = () => {
        p5.resizeCanvas(p5.windowWidth, p5.windowHeight);
        let min = p5.min(p5.windowWidth, p5.windowHeight);
        if(min < 800){
            pixelSize = 1;
        }else if (min < 2000){
            pixelSize = 2;
        }else if (min < 4000){
            pixelSize = 3;
        }else{
            pixelSize = 4;
        }
        let cols = p5.floor(p5.width / pixelSize);
        let rows = p5.floor(p5.height / pixelSize);
        globalThis.buffer = p5.createGraphics(cols, rows);
        buffer.translate(p5.int(buffer.width / 2), p5.int(buffer.height / 2));

        globalThis.bufferTop = p5.createGraphics(cols, rows);
        bufferTop.translate(p5.int(bufferTop.width / 2), p5.int(bufferTop.height / 2));

        for(let key in screens){
            screens[key].windowResized();
        }

        p5.textFont(globalThis.font);
        buffer.textFont(globalThis.font);
    }

    p5.keyPressed = () => {
        if(p5.key === 'F1'){
            showDebug = !showDebug;
        }else if(p5.key === 'F2'){
            //test cutscene
            currentScreen = "cutScene";
            iScreen = screens[currentScreen];
            (<CutSceneScreen> iScreen).loadVideo("test2");
        }

        iScreen.keyPressed();
    }
        

    p5.keyReleased = () => {
        iScreen.keyReleased();
    }

    p5.mousePressed = () => {
        iScreen.mousePressed();
    }

    p5.mouseReleased = () => {
        iScreen.mouseReleased();
    }

    p5.touchStarted = () => {
        iScreen.touchStarted();
    }

    p5.touchEnded = () => {
        iScreen.touchEnded();
    }

    p5.touchMoved = () => {
        iScreen.touchMoved();
        return false;
    }

    p5.mouseWheel = (event) => {
        iScreen.mouseWheel(event);
    }

    function drawCursor(){
        let cursorSize = 8;
        let posX = p5.int((p5.mouseX/pixelSize) - (buffer.width/2));
        let posY = p5.int((p5.mouseY/pixelSize) - (buffer.height/2));
        buffer.stroke(255);
        buffer.strokeWeight(2);
        buffer.line(posX-cursorSize, posY, posX+cursorSize, posY);
        buffer.line(posX, posY-cursorSize, posX, posY+cursorSize);
    }

    function detectMobile() : boolean{
        let details = navigator.userAgent;
        let regexp = /android|iphone|kindle|ipad/i;
        let isMobileDevice = regexp.test(details);
        return isMobileDevice;
    }
}

new P5(sketch);